var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(_vm.item)?_c('span',_vm._g({class:_vm.get_color(_vm.item),style:(_vm.item.attendence == 'P' ? 'cursor: pointer' : ''),domProps:{"textContent":_vm._s(_vm.item.attendence == 'P' ? _vm.item.no_of_swipes : _vm.item.attendence)},on:{"click":function($event){_vm.item.attendence == 'P' ? _vm.GeoDialog(_vm.item) : ''}}},on)):_vm._e()]}}])},[(_vm.item)?_c('span',{staticClass:"white--text",domProps:{"textContent":_vm._s(
        _vm.item.attendence == 'P'
          ? 'View Geo Swipes'
          : _vm.item.attendence == 'W/O'
          ? 'Week Off'
          : _vm.item.attendence == 'A'
          ? 'Absent'
          : _vm.item.attendence == 'H'
          ? 'Holiday'
          :_vm.item.attendence=='FL'
          ?'Full Leave'
          :_vm.item.attendence=='HL'
          ?'Half Leave'
          : _vm.item.attendence
      )}}):_vm._e()]),_c('ViewGeoSwipeCount',{attrs:{"geoDialog":_vm.geoDialog,"item":_vm.item,"userName":_vm.userName},on:{"close_dialog":function($event){_vm.geoDialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }